export enum TicketsApiTag {
  ticket = "ticket",
  ticketsStats = "ticketsStats",
}
